import { apiFetch, getApiUrl } from './client';

export interface GarmentItem {
  id: number;
  sort_index: number;
  name: string;
  category: string;
  visibility: string;
  reason: string;
  boxes: number[][];
  models: string[];
  updated_by: string;
  visibility_note: string;
}

export interface GarmentSample {
  id: number;
  sample_key: string;
  image_file: string;
  qc_status: string;
  items: GarmentItem[];
}

export interface GarmentPage {
  total: number;
  offset: number;
  open_offset: number;
  open_total: number;
  visibility_total: number;
  feet_total: number;
  sample: GarmentSample | null;
}

export function listGarmentSample(offset: number, queue: '' | 'risk' | 'visibility' | 'feet' = '', atOpen = false) {
  const selected = queue ? `&queue=${queue}` : '';
  const open = atOpen ? '&at=open' : '';
  return apiFetch<GarmentPage>(`/v1/garment-locate/samples?offset=${offset}${selected}${open}`);
}

export function keepGarmentVisibility(id: number) {
  return apiFetch<GarmentItem>(`/v1/garment-locate/items/${id}/visibility-keep`, { method: 'POST' });
}

export function finishGarmentVisibility(id: number) {
  return apiFetch<{ ok: boolean }>(`/v1/garment-locate/samples/${id}/visibility-done`, { method: 'POST' });
}

export function listGarmentCategories() {
  return apiFetch<{ categories: string[] }>('/v1/garment-locate/categories');
}

export function garmentImageUrl(sampleId: number) {
  return getApiUrl(`/v1/garment-locate/samples/${sampleId}/image`);
}

export function createGarmentItem(
  sampleId: number,
  body: Pick<GarmentItem, 'name' | 'category' | 'visibility' | 'boxes'> & { models?: string[] }
) {
  return apiFetch<GarmentItem>(`/v1/garment-locate/samples/${sampleId}/items`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function deleteGarmentSample(id: number) {
  return apiFetch<{ ok: boolean }>(`/v1/garment-locate/samples/${id}`, { method: 'DELETE' });
}

export function markGarmentSample(id: number) {
  return apiFetch<{ ok: boolean }>(`/v1/garment-locate/samples/${id}/qc`, { method: 'POST' });
}

export function deleteGarmentItem(id: number) {
  return apiFetch<{ ok: boolean }>(`/v1/garment-locate/items/${id}`, { method: 'DELETE' });
}

export function updateGarmentItem(
  id: number,
  body: Pick<GarmentItem, 'name' | 'category' | 'visibility' | 'boxes'>
) {
  return apiFetch<GarmentItem>(`/v1/garment-locate/items/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}
